
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'

/** 範囲指定のデータ型(ライブラリに合わせた型定義) */
type DateTimeRange = {
  /** 開始日時 */
  start: number | null
  /** 終了日時 */
  end: number | null
}

/**
 * 日時の範囲選択ピッカー
 */
@Component
export default class DateTimeRangePicker extends Vue {
  /** 日時指定ピッカー(ライブラリ、型定義が無いため例外的にany型を使用) */
  @Ref()
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private vDatePicker!: any

  /** 分数プルダウンの刻み数(ライブラリオプション) */
  @Prop({ default: 10 })
  private minuteIncrement!: number

  /** 選択可能日付の最小値(ライブラリオプション) */
  @Prop({ default: null })
  private minDate!: Date | null

  /** 開始日時の初期値(unixミリ秒) */
  @Prop({ default: null })
  private defaultStartTime!: number | null

  /** 終了日時の初期値(unixミリ秒) */
  @Prop({ default: null })
  private defaultEndTime!: number | null

  /** 選択されるデータ型の定義(ライブラリオプション) */
  private MODEL_CONFIG = {
    type: 'number',
  }

  /** 選択値 */
  private value: DateTimeRange = {
    start: null,
    end: null,
  }

  /**
   * 初期処理
   */
  private mounted(): void {
    // 初期値は開始・終了の両方を設定した場合のみ有効
    if (this.defaultStartTime && this.defaultEndTime) {
      this.vDatePicker.updateValue({
        start: this.defaultStartTime,
        end: this.defaultEndTime,
      })
    }
  }

  /**
   * 入力済み判定
   *
   * @returns 入力済みの場合はtrue、そうでなければfalse
   */
  public get isInputed(): boolean {
    // 開始・終了どちらも値が存在すればtrue(実際はライブラリ側のチェックが掛かるため、片方のみ入力は起きない想定)
    return !!(this.value.start && this.value.end)
  }

  /**
   * 使用先からの開始日時参照用メソッド(未入力の場合は0)
   *
   * @returns 開始日時(unixミリ秒)
   */
  public get startTime(): number {
    return this.value.start || 0
  }

  /**
   * 使用先からの終了日時参照用メソッド(未入力の場合は0)
   *
   * @returns 終了日時(unixミリ秒)
   */
  public get endTime(): number {
    return this.value.end || 0
  }
}
